import { useState } from 'react';

export function useDownloadCv() {
  const [isLoading, setIsLoading] = useState(false);
  const handleDownload = ({ url, name }: { url: string; name: string }) => {
    setIsLoading(true);
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        setIsLoading(false);
        const url = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement('a');
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };
  return { handleDownload, isLoading };
}
